import React, { useState, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RFQModal from "../components/RFQModal";
import { LuChevronLeft, LuChevronRight } from "react-icons/lu";

import {
  LuCar,
  LuLandmark,
  LuShieldCheck,
  LuHeadset,
  LuShoppingBag,
  LuZap,
  LuCalendarDays,
  LuBriefcase,
  LuWallet,
  LuGamepad2,
  LuHeartHandshake,
  LuTruck,
  LuWifi,
  LuHouse,
  LuMonitorSmartphone,
  LuPhoneCall,
} from "react-icons/lu";

import "../assets/css/OutcessClients.css";

import {
  automobile,
  banking,
  backgroundScreening,
  bpo,
  ecommerce,
  energy,
  eventManagement,
  financialInstitution,
  fintech,
  gambling,
  insurance,
  logistics,
  mvno,
  realEstate,
  sales,
  telecom,
} from "../Library/Libraries";

const industries = [
  {
    title: "Automobile",
    key: "Automobile",
    icon: <LuCar />,
    data: automobile,
  },
  {
    title: "Banking",
    key: "Banking",
    icon: <LuLandmark />,
    data: banking,
  },
  {
    title: "Background Screening and Employment Services",
    key: "Background Screening",
    icon: <LuShieldCheck />,
    data: backgroundScreening,
  },
  {
    title: "BPO Outsourcing",
    key: "BPO",
    icon: <LuHeadset />,
    data: bpo,
  },
  {
    title: "E-commerce",
    key: "E-commerce",
    icon: <LuShoppingBag />,
    data: ecommerce,
  },
  {
    title: "Energy",
    key: "Energy",
    icon: <LuZap />,
    data: energy,
  },
  {
    title: "Event Management",
    key: "Event Management",
    icon: <LuCalendarDays />,
    data: eventManagement,
  },
  {
    title: "Financial Institution",
    key: "Financial",
    icon: <LuBriefcase />,
    data: financialInstitution,
  },
  {
    title: "Fintech",
    key: "Fintech",
    icon: <LuWallet />,
    data: fintech,
  },
  {
    title: "Gambling",
    key: "Gambling",
    icon: <LuGamepad2 />,
    data: gambling,
  },
  {
    title: "Insurance",
    key: "Insurance",
    icon: <LuHeartHandshake />,
    data: insurance,
  },
  {
    title: "Logistics",
    key: "Logistics",
    icon: <LuTruck />,
    data: logistics,
  },
  {
    title: "MVNO",
    key: "MVNO",
    icon: <LuWifi />,
    data: mvno,
  },
  {
    title: "Real Estate",
    key: "Real Estate",
    icon: <LuHouse />,
    data: realEstate,
  },
  {
    title: "Sales",
    key: "Sales",
    icon: <LuMonitorSmartphone />,
    data: sales,
  },
  {
    title: "Telecommunication",
    key: "Telecommunication",
    icon: <LuPhoneCall />,
    data: telecom,
  },
];

const OutcessClients = () => {
  const [show, setShow] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState("All");

  const filteredIndustries =
    selectedIndustry === "All"
      ? industries
      : industries.filter((industry) => industry.key === selectedIndustry);

  const pillsRef = useRef(null);
  const scrollRight = () => {
    const el = pillsRef.current;

    const maxScroll = el.scrollWidth - el.clientWidth;

    el.scrollTo({
      left: Math.min(el.scrollLeft + 300, maxScroll),
      behavior: "smooth",
    });
  };

  const scrollLeft = () => {
    const el = pillsRef.current;

    el.scrollTo({
      left: Math.max(el.scrollLeft - 300, 0),
      behavior: "smooth",
    });
  };
  return (
    <div id="clients-page">
      <Navbar />

      {/* HERO */}

      <section className="clients-hero">
        <div className="container">
          <span className="section-tag" data-aos="fade-down">
            OUR CLIENTS
          </span>

          <h1 data-aos="fade-up" data-aos-delay="150">
            Brands people rely on,
            <br />
            relying on us.
          </h1>

          <p data-aos="fade-up" data-aos-delay="300">
            From national telecoms to fast-growing fintechs, 60+ organizations across 15+ industries trust Outcess to run the operations behind their customer experience.
          </p>
        </div>
      </section>

      {/* STATS */}

      <section className="clients-stats">
        <div className="container">
          <div className="stats-grid sm:p-0">
            {[
              {
                value: "60+",
                label: "Brands Served",
              },
              {
                value: "15+",
                label: "Industries",
              },
              {
                value: "20+",
                label: "Years in Operation",
              },
              {
                value: "30.5M+",
                label: "Interactions Managed Yearly",
              },
            ].map((stat, index) => (
              <div
                className="stat"
                key={index}
                data-aos="zoom-in"
                data-aos-delay={index * 150}
              >
                <h2>{stat.value}</h2>

                <span>{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <main>
        <div className="container p-0">
          {/* FILTERS */}

          <div className="industry-pills-wrapper flex">
            <button className="scroll-btn left" onClick={scrollLeft}>
              <LuChevronLeft />
            </button>

            <div ref={pillsRef} className="industry-pills" data-aos="fade-up">
              <button
                className={`industry-pill ${
                  selectedIndustry === "All" ? "active" : ""
                }`}
                onClick={() => setSelectedIndustry("All")}
              >
                All
              </button>

              {industries.map((industry) => (
                <button
                  key={industry.key}
                  className={`industry-pill ${
                    selectedIndustry === industry.key ? "active" : ""
                  }`}
                  onClick={() => setSelectedIndustry(industry.key)}
                >
                  {industry.title}
                </button>
              ))}
            </div>

            <button className="scroll-btn right" onClick={scrollRight}>
              <LuChevronRight />
            </button>
          </div>
          {/* INDUSTRIES */}

          {filteredIndustries.map((industry, index) => (
            <section
              key={industry.key}
              className="industry-section"
              data-aos="fade-up"
              data-aos-duration="800"
              data-aos-once="true"
            >
              <div className="industry-title">
                <span>{industry.icon}</span>

                <h3>{industry.title}</h3>
              </div>

              <div className="clients-grid">
                {industry.data.map((client, i) => (
                  <div
                    key={i}
                    className="client-card"
                    data-aos="fade-up"
                    data-aos-delay={i * 120}
                  >
                    <img
                      src={client.logo || client.img}
                      alt={client.name || industry.title}
                    />

                    {client.description && <p>{client.description}</p>}
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>

      {/* CTA */}

      <section className="clients-cta" data-aos="fade-up">
        <div className="container">
          <h2>Your brand could be next on this page.</h2>

          <p>
            See what a partnership with Outcess actually looks like, industry by
            industry.
          </p>

          <button className="ccsnl-btn" onClick={() => setShow(true)}>
            Book a Demo
          </button>
        </div>
      </section>

      <RFQModal show={show} setShow={setShow} />

      <Footer />
    </div>
  );
};

export default OutcessClients;
